const PREFIX = 'topic_progress_v1_';

function normalizedSegment(value, fallback) {
  const segment = String(value || '').trim().toLowerCase();
  return /^[a-z0-9_-]+$/.test(segment) ? segment : fallback;
}

function storageKey(langPair, language, level) {
  return [
    PREFIX,
    normalizedSegment(langPair, 'guest'),
    normalizedSegment(language, 'unknown'),
    normalizedSegment(level, 'a1'),
  ].join('_');
}

function readCompleted(langPair, language, level) {
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey(langPair, language, level)) || '[]');
    return Array.isArray(saved)
      ? [...new Set(saved.filter((id) => typeof id === 'string' && id.trim()).map((id) => id.trim()))]
      : [];
  } catch {
    return [];
  }
}

function notify(langPair, language, level) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('topic-progress-changed', {
    detail: { langPair, language, level },
  }));
}

export const TopicProgressService = {
  snapshot(langPair, language, level, lessonIds = []) {
    const validIds = [...new Set(lessonIds.map(String))];
    const validSet = new Set(validIds);
    const completedIds = readCompleted(langPair, language, level)
      .filter((id) => validSet.has(id));
    return {
      completedIds,
      completedCount: completedIds.length,
      percent: validIds.length ? Math.round((completedIds.length / validIds.length) * 100) : 0,
      isComplete: validIds.length > 0 && completedIds.length === validIds.length,
    };
  },

  completeLesson(langPair, language, level, lessonId, lessonIds = []) {
    const id = String(lessonId || '').trim();
    const validIds = [...new Set(lessonIds.map(String))];
    if (!id || !validIds.includes(id)) {
      return this.snapshot(langPair, language, level, validIds);
    }
    const completed = readCompleted(langPair, language, level);
    if (!completed.includes(id)) {
      localStorage.setItem(
        storageKey(langPair, language, level),
        JSON.stringify([...completed, id]),
      );
      notify(langPair, language, level);
    }
    return this.snapshot(langPair, language, level, validIds);
  },
};
